/* eslint-disable camelcase */
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useSelector } from 'react-redux';
import NotAchievedIcon from '../../../assets/SadFace.png';
import CompletedIcon from '../../../assets/Smileface.png';
import { FollowUpPeriodResult } from '../followUpPeriodResult/FollowUpPeriodResult';
import { metricValueFormat } from '../../../utils/metricValueFormat';
import {
    useCalculateNextBestActionAssociateMutation,
    useCloseCoachingActionPlanMutation,
    useFollowupPeriodResultQuery, useInsertCoachingSessionMutation

} from '../coachingActionPlanSlice';
import CoachingShoutOut from '../../../components/coachingShoutOut/coachingShoutOUt';
import { CoachingEntityTypes, CoachingTabs } from '../../../utils/typeConstants';
import { selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import { ROLES } from '../../../constants';

export const FollowUpResultPerformance: React.FC<{
    CAPSession: any,
    onBackToPrepare?: (() => void) | undefined,
    metricIndex: number

}> = ({
    CAPSession,
    onBackToPrepare,
    metricIndex,
}) => {
        const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
        const [insertCoachingSession] = useInsertCoachingSessionMutation();
        const [dailyData, setDailyData] = useState<any>(null);
        const [lastSessionData, setLastSessionData] = useState<any>(null);
        const [shoutoutVisible, setShoutoutVisible] = useState<boolean>(false);
        const [shoutoutResult, setShoutoutResult] = useState<any>(null);
        const [closeActionPlan] = useCloseCoachingActionPlanMutation();
        const [calculateNextBestAction] = useCalculateNextBestActionAssociateMutation();

        const { data: FollowupPeriod } = useFollowupPeriodResultQuery({
            employeeNumber: CAPSession?.employeeNumber,
            scorecardVersionId: CAPSession?.scorecardVersionId,
            metricId: CAPSession?.metricId,
            fromDate: lastSessionData?.sessionStartDate,
            toDate: CAPSession?.coachingActionPlanStatusId === 3 && CAPSession?.coachingCompleteDate
                ? CAPSession.coachingCompleteDate
                : `${(new Date().getMonth() + 1).toString().padStart(2, '0')}/${new Date().getDate().toString().padStart(2, '0')}/${new Date().getFullYear()} 00:00:00`,
        },
            {
                skip: !lastSessionData?.sessionStartDate
            }
        );

        useEffect(() => {
            if (FollowupPeriod?.data && FollowupPeriod.data.length > 0) {
                setDailyData(FollowupPeriod.data);
            }
        }, [FollowupPeriod]);

        useEffect(() => {
            if (CAPSession) {
                const lastSession = CAPSession?.sessions?.reduce((max: any, session: any) =>
                    session.sessionNumber > max.sessionNumber ? session : max
                );
                setLastSessionData(lastSession);
            } else {
                setLastSessionData(null);
            }
        }, [CAPSession]);

        const handleCloseActionPlan = async () => {
                if (!CAPSession?.coachingActionPlanId) {
                    toast.error('No action plan ID available');
                    return;
                }
        
                try {
                    await closeActionPlan(CAPSession.coachingActionPlanId).unwrap();        
                    try {
                        await calculateNextBestAction({
                            scorecardVersionId: CAPSession.scorecardVersionId,
                            employeeNumber: CAPSession.employeeNumber,
                        }).unwrap();
                        onBackToPrepare?.();
                    } catch (nbaError) {
                        console.error('NBA recalculation failed:', nbaError);
                    }        
                } catch (error) {
                    console.error('Close action plan failed:', error);
                    toast.error('Failed to close action plan. Please try again.');
                }
            };
        useEffect(() => {
            if (shoutoutResult) {
                if (CAPSession?.coachingNextBestActionTypeId === 2 && shoutoutResult === 'Shoutout saved successfully') {
                    try {
                        handleCloseActionPlan();
                    } catch (error) {
                        console.error('Close action plan failed:', error);
                        toast.error('Failed to close action plan. Please try again.');
                    }
                    setShoutoutResult(null);
                }
            }
        }, [shoutoutResult]);

        const getStatusIcon = (statusType: boolean) => {
            const statusIcons: Record<string, string> = {
                false: NotAchievedIcon,
                true: CompletedIcon,
            };
            return statusIcons[String(statusType)];
        };

        const handleCreateNewFollowUp = () => {

            const today = new Date();
            const dayOfWeek = today.getDay();
            const daysUntilMonday = (8 - dayOfWeek) % 7 || 7;
            const nextMonday = new Date(today);
            nextMonday.setDate(today.getDate() + daysUntilMonday);

            const newSession = {
                coachingActionPlanId: CAPSession.coachingActionPlanId,
                sessionNumber: lastSessionData?.sessionNumber === null || lastSessionData?.sessionNumber === undefined ? 0 : lastSessionData.sessionNumber + 1,
                metricCurrentValue: lastSessionData?.metricResultValue,
                metricTargetValue: lastSessionData?.metricTargetValue,
                coachingActionPlanSessionId: lastSessionData?.coachingActionPlanSessionId,
                followUpDate: nextMonday.toISOString(),
                performanceCommitment: lastSessionData?.performanceCommitment,
                coachingSkillId: lastSessionData?.coachingSkillId,
                coachingBehaviorId: lastSessionData?.coachingBehaviorId,
                coachingActionId: lastSessionData?.coachingActionId,
                actionDescription: lastSessionData?.actionDescription,
                successCriteria: lastSessionData?.successCriteria,
                notes: lastSessionData?.notes,
                analysisNotes: lastSessionData?.analysisNotes,
                frameNotes: lastSessionData?.frameNotes,
                understandNotes: lastSessionData?.understandNotes,
                exploreNotes: lastSessionData?.exploreNotes,
                sessionCommitmentAttained: lastSessionData?.sessionCommitmentAttained,
                scorecardMetricId: CAPSession?.scorecardMetricId,
                coachingNextBestActionId: CAPSession?.coachingNextBestActionId,
                analysisTypeIds: lastSessionData?.analysisTypes ?? [],
            }

            insertCoachingSession(newSession)
                .unwrap()
                .then((res: any) => {
                    if (res?.data) {
                        toast.success('New follow up session created successfully');
                        // onBackToPrepare?.();
                    } else {
                        toast.error('Error creating new follow up session');
                    }
                })
                .catch(() => {
                    toast.error('Error creating new follow up session');
                });
        }

        const renderShuotOutModal = () => {
            return (
                <CoachingShoutOut
                    receiverId={CAPSession?.employeeNumber}
                    receiverName={CAPSession?.employeeName}
                    visible={shoutoutVisible}
                    setVisible={setShoutoutVisible}
                    coachingEntityTypeId={CoachingEntityTypes.CoachingActionPlan}
                    coachingEntityId={CAPSession?.coachingActionPlanId}
                    scorecardMetricId={CAPSession?.scorecardMetricId}
                    coreValueId={0}
                    via={CoachingTabs.CoachingActionPlan}
                    result={setShoutoutResult}
                />
                // <CoachingShoutOut
                //     receiverId={CAPSession?.employeeNumber}
                //     receiverName={CAPSession?.employeeName}
                //     visible={shoutoutVisible}
                //     setVisible={setShoutoutVisible}
                //     coachingEntityId={CAPSession?.scorecardMetricId}
                //     coachingEntityTypeId={CoachingEntityTypes.CoachingMetricRecognition}
                //     coreValueId={0}
                //     via={CoachingTabs.CoachingActionPlan}
                //     result={setShoutoutResult}
                // />
            );
        };

        return (
            <div>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '32px',
                        marginBottom: '24px',
                    }}
                >
                    <div className="metric-item">
                        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
                            Current Performance
                        </div>
                        <div style={{ fontSize: '24px', fontWeight: 600, color: '#1f2937' }}>
                            {metricValueFormat(lastSessionData?.metricResultValue, CAPSession?.metricTypeName)}
                        </div>
                    </div>
                    <div className="metric-item">
                        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
                            Performance Commitment
                        </div>
                        <div style={{ fontSize: '24px', fontWeight: 600, color: '#1f2937' }}>
                            {metricValueFormat(lastSessionData?.performanceCommitment, CAPSession?.metricTypeName)}
                        </div>
                    </div>
                    <div className="metric-item">
                        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
                            Scorecard Target
                        </div>
                        <div style={{ fontSize: '24px', fontWeight: 600, color: '#1f2937' }}>
                            {metricValueFormat(lastSessionData?.metricTargetValue, CAPSession?.metricTypeName)}
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '32px' }}>
                    <div style={{ flex: 1 }}>
                        <div
                            style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937', marginBottom: '16px' }}
                        >
                            Status
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '12px',
                                marginBottom: '12px',
                            }}
                        >
                            <img
                                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                alt="Status Icon"
                                src={getStatusIcon(lastSessionData?.sessionCommitmentAttained ?? false)}
                            />
                            <div style={{ flex: 1 }}>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        color: lastSessionData?.sessionCommitmentAttained ? '#2AA154' : '#C90370',
                                    }}
                                >
                                    {lastSessionData?.sessionCommitmentAttained ? 'Metric Attained' : 'Metric Not Attained'}
                                </div>
                            </div>
                            {userManagerLevel && ROLES.Supervisor.includes(userManagerLevel) && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    {CAPSession?.coachingNextBestActionTypeId === 2 /* Recognize */ && (
                                        <Button
                                            icon="pi pi-arrow-circle-right"
                                            label="Recognize"
                                            style={{
                                                borderRadius: '20px',
                                                backgroundColor: '#2AA154',
                                                padding: '0.3rem 1.5rem',
                                                fontSize: '1rem',
                                                border: 'none',
                                            }}
                                            onClick={() => setShoutoutVisible(true)}
                                        />
                                    )}

                                    {CAPSession?.coachingNextBestActionTypeId === 3 /* Follow Up */ && (
                                        <Button
                                            label="Start New Follow Up"
                                            icon="pi pi-arrow-circle-down"
                                            style={{
                                                borderRadius: '20px',
                                                backgroundColor: '#C7E3FF',
                                                color: '#1A5AA5',
                                                padding: '0.3rem 1.5rem',
                                                fontSize: '1rem',
                                                border: 'none',
                                            }}
                                            onClick={handleCreateNewFollowUp}
                                        />
                                    )}
                                </div>)}
                        </div>
                    </div>

                    <div style={{ flex: 1 }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '12px',
                            }}
                        >
                            <div style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937' }}>
                                Period Results
                            </div>
                        </div>
                        <FollowUpPeriodResult
                            metricIndex={metricIndex}
                            dailyData={dailyData}
                        />
                    </div>
                </div>
                {shoutoutVisible && renderShuotOutModal()}
            </div>
        );
    };
